import { LoadingIndicator } from "@anchor/react-components/dist/lib/components";
import {
  McButton,
  McIcon,
  McInput,
  McModal,
  McTextarea,
  McTooltip,
} from "@maersk-global/mds-react-wrapper/components-core";
import { AiSuggestionsInline } from "../Report/RcaQualityPanel";
import React, { useEffect, useRef, useState, useCallback } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Comments from "../Comments/Comments";
import Collaborators from "../Collaborators/Collaborators";
import "./incSumm.css";
import "../Metadata/Style.css";
import { Col, Row } from "react-bootstrap";
import UserInfo from "../../context/UserAccessContext";
import PhotoUploadModal from "../PhotoUploadModal/PhotoUploadModal";
import Images from "../Images/Images";
import UseHandleFileUpload from "../../Utils/UseHandleFileUpload";
import UploadedImages from "../Images/UploadedImages";
import PhotoPreviewModal from "../PhotoPreviewModal/PhotoPreviewModal";
import { ImageServices } from "../../services/imageServices";
import { useMsal } from "@azure/msal-react";

// Helper to check if HTML content has meaningful content (minimum 50 characters)
const hasMinimumContent = (html, minChars = 50) => {
  if (!html) return false;
  const text = html.replace(/<[^>]*>/g, "").trim();
  return text.length >= minChars;
};

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const QUILL_FORMATS = [
  "header",
  "bold", "italic", "underline",
  "list", "bullet",
  "link",
];

// import { useWebSocket } from "../../context/WebSocketContext/WebSocketContext";

const Loading = () => {
  return (
    <LoadingIndicator
      appearance="default"
      fit="large"
      id="testing"
      label="Fetching images, Please Wait..."
      variant="spinner"
      style={{ background: "none" }}
    />
  );
};

const IsLocked = ({ field, lockedFields, graphData }) => {
  if (!lockedFields || Object.keys(lockedFields).length === 0) return null;
  const lockedField = lockedFields.find(
    (lockedField) =>
      lockedField.fieldName === field &&
      lockedField.lockedBy !== graphData.username
  );
  return (
    <div>
      {lockedField ? (
        <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
          {lockedField.lockedBy} is Editing..
        </div>
      ) : null}
    </div>
  );
};

function IncidentSummary(props) {
  const [incSummData, setIncSummData] = useState({
    incSummDescription: "",
    preceEventsDescription: "",
    impact: "",
    detectionAndResponseDescription: "",
    mttd: 0,
    mttrespond: 0,
    mttrepair: 0,
    mttrecover: "0.00", // Initialize as string with 2 decimal places
    customMttrepair: false,
    changedFileds: {},
    lockedFields: [],
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);
  const savingInProgressRef = useRef(false);
  const [showFormatGuide, setShowFormatGuide] = useState(false);
  const { userIsAdmin, graphData } = UserInfo();
  const { instance, accounts } = useMsal();
  const { getImage } = ImageServices();

  // Image upload states
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [photosFor, setPhotosFor] = useState("summary");
  const [photoModal, setPhotoModal] = useState(false);
  const [imageToPreview, setImageToPreview] = useState({
    preview: "",
    fileName: "",
  });
  const [previewModal, setPreviewModal] = useState(false);
  const [uploadedSummaryImages, setUploadedSummaryImages] = useState([]);
  
  // Wrap setState to log changes
  const setUploadedSummaryImagesWithLog = (images) => {
    console.log('[IncSumm] Setting uploadedSummaryImages to:', images, 'length:', images?.length);
    setUploadedSummaryImages(images);
  };
  
  const [fetchAgain, setFetchAgain] = useState(false);
  
  // Debug log for fetchAgain changes
  useEffect(() => {
    console.log('[IncSumm] fetchAgain state changed to:', fetchAgain);
  }, [fetchAgain]);
  
  // Debug log for uploadedSummaryImages changes
  useEffect(() => {
    console.log('[IncSumm] uploadedSummaryImages state changed to:', uploadedSummaryImages, 'length:', uploadedSummaryImages?.length);
  }, [uploadedSummaryImages]);
  
  const [loadingImage, setLoadingImage] = useState({ summary: false });
  const [errorInFetchingImages, setErrorInFetchingImages] = useState({ summaryImages: false });

  const [
    errorStatesForDetectionAndResponse,
    setErrorStatesForDetectionAndResponse,
  ] = useState({
    mttdError: {
      error: false,
      message: "",
    },
    mttrespondError: {
      error: false,
      message: "",
    },
    mttrepairError: {
      error: false,
      message: "",
    },
    mttrecoverError: {
      error: false,
      message: "",
    },
  });

  // const { lockField, unlockField } = useWebSocket();
  const lockField = null; // WebSocket disabled
  const unlockField = null; // WebSocket disabled

  // Image upload handlers
  const handlePhotoModalClick = (photoFor) => {
    setPhotosFor(photoFor);
    setPhotoModal(true);
  };

  const handlePhotoModalClose = () => {
    setPhotoModal(false);
  };

  const hanldePreviewModal = () => {
    setPreviewModal(!previewModal);
  };

  const { handleFiles, fileChange, deleteImage, previewImage } =
    UseHandleFileUpload(
      props.images,
      setError,
      setErrorMessage,
      photosFor,
      hanldePreviewModal,
      setImageToPreview,
      props.dispatch,
      props.imageFormData,
      "incidentSummary",
      setFetchAgain,
      props.incidentID
    );

  // Wrap fileChange to close modal after upload
  const fileChangeWithModalClose = async (data) => {
    await fileChange(data);
    // Close modal after successful upload
    setTimeout(() => {
      handlePhotoModalClose();
    }, 500);
  };

  // Fetch images from Azure Blob Storage
  const fetchAndSetImages = useCallback(
    async (setStateFunction, tag) => {
      console.log('[IncSumm] Starting fetchAndSetImages for tag:', tag, 'incidentID:', props.incidentID);
      if (!props.incidentID) return;
      
      setLoadingImage((currentLoadingStates) => ({
        ...currentLoadingStates,
        [tag]: true,
      }));
      setErrorInFetchingImages((currentErrorStates) => {
        let key = tag + "Images";
        return {
          ...currentErrorStates,
          [key]: false,
        };
      });

      try {
        const images = await getImage(
          [],
          props.incidentID,
          tag
        );
        console.log('[IncSumm] Fetched images:', images?.length || 0, 'images for tag:', tag, 'actual images:', images);
        setStateFunction(images);
        console.log('[IncSumm] Set state with images, array length:', images?.length);
      } catch (error) {
        console.error("Error fetching images:", error);
        setErrorInFetchingImages((currentErrorStates) => {
          let key = tag + "Images";
          return {
            ...currentErrorStates,
            [key]: true,
          };
        });
      } finally {
        setLoadingImage((currentLoadingStates) => ({
          ...currentLoadingStates,
          [tag]: false,
        }));
      }
    },
    [props.incidentID, instance, accounts]
  );

  useEffect(() => {
    console.log('[IncSumm useEffect] Triggered - fetchAgain:', fetchAgain, 'incidentID:', props.incidentID, 'currentStep:', props.currentStep);
    console.log('[IncSumm useEffect] Condition check - has incidentID?', !!props.incidentID, 'currentStep === 0?', props.currentStep === 0);
    if (props.incidentID && props.currentStep === 0) {
      console.log('[IncSumm useEffect] Calling fetchAndSetImages');
      fetchAndSetImages(setUploadedSummaryImagesWithLog, "summary");
    } else {
      console.log('[IncSumm useEffect] Skipping fetch - condition not met');
    }
  }, [fetchAgain, fetchAndSetImages, props.incidentID, props.currentStep]);

  const handleFieldLocking = (fieldName) => {
    // lockField(fieldName, graphData.username);
    // WebSocket disabled
  };

  const handleFieldUnlocking = (fieldName) => {
    // unlockField(fieldName, incSummData);
    // WebSocket disabled
  };

  // Detect if this is a legacy incident (has content in old separate fields)
  const isLegacyFormat = React.useMemo(() => {
    const hasPrecedingEvents = props.incidentSummaryState?.preceEventsDescription?.trim();
    const hasImpact = props.incidentSummaryState?.impact?.trim();
    const hasDetectionResponse = props.incidentSummaryState?.detectionAndResponseDescription?.trim();

    return !!(hasPrecedingEvents || hasImpact || hasDetectionResponse);
  }, [props.incidentSummaryState?.preceEventsDescription, props.incidentSummaryState?.impact, props.incidentSummaryState?.detectionAndResponseDescription]);

  useEffect(() => {
    const rawText = props.incidentSummaryState.incSummDescription || "";
    
    // Convert plain text newlines to HTML if needed
    // Check if the text doesn't already have HTML tags
    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(rawText);
    
    let processedText = rawText;
    if (!hasHtmlTags && rawText.includes('\n')) {
      // Split by newlines and wrap each line in <p> tags
      const lines = rawText.split('\n').filter(line => line.trim());
      processedText = lines.map(line => `<p>${line}</p>`).join('');
    } else if (!hasHtmlTags) {
      // If no newlines and no HTML, wrap in a single <p> tag
      processedText = rawText.trim() ? `<p>${rawText}</p>` : rawText;
    }

    setIncSummData((prevState) => ({
      ...prevState,
      incSummDescription: processedText,
    }));
  }, [props.incidentSummaryState?.incSummDescription]);

  useEffect(() => {
    const rawText = props.incidentSummaryState.preceEventsDescription || "";
    
    // Convert plain text newlines to HTML if needed
    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(rawText);
    
    let processedText = rawText;
    if (!hasHtmlTags && rawText.includes('\n')) {
      const lines = rawText.split('\n').filter(line => line.trim());
      processedText = lines.map(line => `<p>${line}</p>`).join('');
    } else if (!hasHtmlTags) {
      processedText = rawText.trim() ? `<p>${rawText}</p>` : rawText;
    }

    setIncSummData((prevState) => ({
      ...prevState,
      preceEventsDescription: processedText,
    }));
  }, [props.incidentSummaryState?.preceEventsDescription]);

  useEffect(() => {
    const rawText = props.incidentSummaryState.impact || "";
    
    // Convert plain text newlines to HTML if needed
    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(rawText);
    
    let processedText = rawText;
    if (!hasHtmlTags && rawText.includes('\n')) {
      const lines = rawText.split('\n').filter(line => line.trim());
      processedText = lines.map(line => `<p>${line}</p>`).join('');
    } else if (!hasHtmlTags) {
      processedText = rawText.trim() ? `<p>${rawText}</p>` : rawText;
    }

    setIncSummData((prevState) => ({
      ...prevState,
      impact: processedText,
    }));
  }, [props.incidentSummaryState?.impact]);

  useEffect(() => {
    const rawText = props.incidentSummaryState.detectionAndResponseDescription || "";
    
    // Convert plain text newlines to HTML if needed
    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(rawText);
    
    let processedText = rawText;
    if (!hasHtmlTags && rawText.includes('\n')) {
      const lines = rawText.split('\n').filter(line => line.trim());
      processedText = lines.map(line => `<p>${line}</p>`).join('');
    } else if (!hasHtmlTags) {
      processedText = rawText.trim() ? `<p>${rawText}</p>` : rawText;
    }

    setIncSummData((prevState) => ({
      ...prevState,
      detectionAndResponseDescription: processedText,
    }));
  }, [props.incidentSummaryState?.detectionAndResponseDescription]);

  useEffect(() => {
    setIncSummData((prevState) => ({
      ...prevState,
      mttd: props.incidentSummaryState.mttd || 0,
    }));
  }, [props.incidentSummaryState?.mttd]);

  useEffect(() => {
    setIncSummData((prevState) => ({
      ...prevState,
      mttrespond: props.incidentSummaryState.mttrespond || 0,
    }));
  }, [props.incidentSummaryState?.mttrespond]);

  useEffect(() => {
    setIncSummData((prevState) => ({
      ...prevState,
      mttrepair: props.incidentSummaryState.mttrepair || 0,
    }));
  }, [props.incidentSummaryState?.mttrepair]);

  useEffect(() => {
    const roundedMttrepair = parseFloat(parseFloat(incSummData.mttrepair || 0).toFixed(2));
    const roundedMttrespond = parseFloat(parseFloat(incSummData.mttrespond || 0).toFixed(2));
    const roundedMttd = parseFloat(parseFloat(incSummData.mttd || 0).toFixed(2));

    const newMttrecover = (roundedMttrepair + roundedMttrespond + roundedMttd).toFixed(2);

    setIncSummData((prevState) => ({
      ...prevState,
      mttrecover: newMttrecover,
      changedFileds: {
        ...prevState.changedFileds,
        mttrecover: true,
      },
    }));
  }, [incSummData.mttrepair, incSummData.mttrespond, incSummData.mttd]);

  useEffect(() => {
    setIncSummData((prevState) => ({
      ...prevState,
      changedFileds: { ...props.changedFields },
    }));
  }, [props.changedFields]);

  useEffect(() => {
    if (props.lockedFields !== incSummData.lockedFields) {
      setIncSummData((prevState) => ({
        ...prevState,
        lockedFields: props.lockedFields,
      }));
    }
  }, [props.lockedFields, incSummData.lockedFields]);

  const onSave = async () => {
    savingInProgressRef.current = true;

    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "incidentSummaryState",
      payload: {
        incSummDescription: incSummData.incSummDescription,
        preceEventsDescription: incSummData.preceEventsDescription,
        impact: incSummData.impact,
        detectionAndResponseDescription:
          incSummData.detectionAndResponseDescription,
        mttd: incSummData.mttd,
        mttrespond: incSummData.mttrespond,
        mttrepair: incSummData.mttrepair,
        mttrecover: incSummData.mttrecover,
        comments: props.incidentSummaryState.comments,
        isCustomMttrepair: incSummData.customMttrepair,
      },
    });

    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "changedFileds",
      payload: (prevChangedFileds) => ({
        ...prevChangedFileds,
        ...incSummData.changedFileds,
        incSummDescription: true,
      }),
    });

    handleModal();

    // Trigger backend save after React has processed the dispatches
    if (props.onAutoSave) {
      setTimeout(() => {
        props.onAutoSave();
        savingInProgressRef.current = false;
      }, 100);
    } else {
      savingInProgressRef.current = false;
    }
  };

  useEffect(() => {
    let mttrepair =
      incSummData && !isNaN(parseFloat(incSummData.mttrepair))
        ? parseFloat(parseFloat(incSummData.mttrepair).toFixed(2))
        : 0.0;

    let mttrespond =
      incSummData && !isNaN(parseFloat(incSummData.mttrespond))
        ? parseFloat(parseFloat(incSummData.mttrespond).toFixed(2))
        : 0.0;

    let mttd =
      incSummData && !isNaN(parseFloat(incSummData.mttd))
        ? parseFloat(parseFloat(incSummData.mttd).toFixed(2))
        : 0.0;

    let mttrecover =
      incSummData && !isNaN(parseFloat(incSummData.mttrecover))
        ? parseFloat(parseFloat(incSummData.mttrecover).toFixed(2))
        : 0.0;

    let total = parseFloat((mttrepair + mttrespond + mttd).toFixed(2)) || 0.0;

    if (mttrecover < total) {
      setErrorStatesForDetectionAndResponse((currentState) => {
        return {
          ...currentState,
          mttrecoverError: {
            error: true,
            message: "MTTREC cannot be less than sum of MTTD, MTTR and MTTRE",
          },
        };
      });
    } else {
      setErrorStatesForDetectionAndResponse((currentState) => {
        return {
          ...currentState,
          mttrecoverError: {
            error: false,
            message: "",
          },
        };
      });
    }
  }, [incSummData]);

  const handleChange = (target) => {
    const { name, value } = target;

    if (name === "mttd" || name === "mttrespond" || name === "mttrepair") {
      if (parseFloat(value) < 0.0) {
        return;
      }

      // Parse and round each value to 2 decimal places to avoid floating-point precision issues
      const roundedValue = parseFloat(parseFloat(value).toFixed(2));
      const roundedMttrespond = parseFloat(parseFloat(incSummData.mttrespond || 0).toFixed(2));
      const roundedMttd = parseFloat(parseFloat(incSummData.mttd || 0).toFixed(2));
      const roundedMttrepair = parseFloat(parseFloat(incSummData.mttrepair || 0).toFixed(2));

      if (name === "mttrepair") {
        const calculatedMttrecover = (roundedValue + roundedMttrespond + roundedMttd).toFixed(2);

        setIncSummData((prevData) => ({
          ...prevData,
          [name]: value,
          mttrecover: calculatedMttrecover,
          customMttrepair: true,
        }));
      } else if (name === "mttd") {
        const calculatedMttrecover = (roundedValue + roundedMttrespond + roundedMttrepair).toFixed(2);

        setIncSummData((prevData) => ({
          ...prevData,
          [name]: value,
          mttrecover: calculatedMttrecover,
        }));
      } else {
        if (parseFloat(value) < 0.0) {
          return;
        }
        const calculatedMttrecover = (roundedValue + roundedMttrepair + roundedMttd).toFixed(2);

        setIncSummData((prevData) => ({
          ...prevData,
          [name]: value,
          mttrecover: calculatedMttrecover,
        }));
      }
      setIncSummData((prevData) => ({
        ...prevData,
        changedFileds: {
          ...prevData.changedFileds,
          [name]: true,
          mttrecover: true, // Mark mttrecover as changed since it's recalculated
        },
      }));
    } else {
      setIncSummData((prevData) => ({
        ...prevData,
        [name]: value,
        changedFileds: {
          ...prevData.changedFileds,
          [name]: true,
        },
      }));
    }
  };

  const handleModal = () => {
    setModalOpen((modalCondition) => !modalCondition);
  };

  const shouldShowComments = React.useMemo(() => {
    // Check if required objects exist
    if (!props.postmortemCurrentStatus || !props.incidentSummaryState) {
      return false;
    }

    // Check if not in initial state
    const notInInitialState =

      props.postmortemCurrentStatus.currentState &&
      props.postmortemCurrentStatus.currentState !== "DRAFT";

    // Check if NEW comments exist
    const hasNewComments =
      props.incidentSummaryState &&
      props.incidentSummaryState.comments &&
      Array.isArray(props.incidentSummaryState.comments.NEW) &&
      props.incidentSummaryState.comments.NEW.length > 0;

    // Return true only if both conditions are met

    const inEarlyState =
      props.incidentSummaryState &&
        props.incidentSummaryState.curentState === "DRAFT"

    const hasDoneComments =
      props.incidentSummaryState &&
      props.incidentSummaryState.comments &&
      Array.isArray(props.incidentSummaryState.comments.DONE) &&
      props.incidentSummaryState.comments.DONE.length > 0;

    const hasReviewComments =
      props.incidentSummaryState.comments &&
      Array.isArray(props.incidentSummaryState.comments.INPROGRESS) &&
      props.incidentSummaryState.comments.INPROGRESS.length > 0;

    // Return true if either condition is met
    if (notInInitialState) return true;
    return (
      (hasNewComments) || (inEarlyState && (hasDoneComments || hasReviewComments))
    );
  }, [props.postmortemCurrentStatus, props.incidentSummaryState]);

  const radius = 10;
  return (
    <div className="">
      <Row
        className="incident-summary-wrapper gx-4 mt-2 scrollbar"
      >
        <Col
          xxl={12}
          className="sixth-step incident-summary-content scrollbar"
        >
          <div id="section-incident-summary" className="sre-section-card">
            {/* Section Header */}
            <div className="sre-section-header">
              <span className="sre-section-header-title">Incident Summary</span>
              {hasMinimumContent(incSummData.incSummDescription) ? (
                <span className="sre-section-complete-badge">✓ Complete</span>
              ) : (
                <span className="sre-section-warning-badge">Incomplete</span>
              )}
              <McTooltip position="bottom-right" fit="small" width={320}>
                <McIcon slot="trigger" icon="info-circle" size="16" style={{ cursor: "pointer", color: "#fff" }} />
                <div style={{ fontSize: "12px", lineHeight: "1.6", padding: "4px 0" }}>
                  <strong>SRE Best Practices — Incident Summary</strong>
                  <ul style={{ margin: "6px 0 0", paddingLeft: "16px" }}>
                    <li>Describe what happened from the customer's perspective</li>
                    <li>State the customer-visible impact (errors, latency, outage)</li>
                    <li>Include the full incident timeline (start → detection → resolution)</li>
                    <li>Capture the blast radius: affected services, regions, users</li>
                    <li>Note the business impact (revenue, SLA breach, reputation)</li>
                  </ul>
                </div>
              </McTooltip>
              <span className="sre-section-header-badge" style={{ flex: 1 }} />
              {props.aiInsight && (
                <button
                  className={`sre-section-header-action${aiOpen ? " sre-section-header-action--ai-active" : ""}`}
                  onClick={() => setAiOpen((v) => !v)}
                >
                  <McIcon icon="sparkle" size="12" />
                  AI Review
                  <McIcon icon={aiOpen ? "chevron-up" : "chevron-down"} size="12" />
                </button>
              )}
              {!props.postMortemIsIncompleteState && (
                <button
                  className="sre-section-header-action how-to-edit"
                  onClick={handleModal}
                >
                  <McIcon icon="pencil" size="14" />
                  Edit
                </button>
              )}
            </div>

            <div
              className={`sre-section-body${!props.postMortemIsIncompleteState ? " sre-section-body--editable" : ""}${aiOpen && props.aiInsight ? " sre-section-body--with-ai" : ""}`}
              onClick={!props.postMortemIsIncompleteState ? handleModal : undefined}
            >
              <div className={aiOpen && props.aiInsight ? "sre-section-content" : undefined}>
              <div
                className="incSummary summary"
                style={{
                  ...(Array.isArray(incSummData.lockedFields) &&
                    incSummData.lockedFields.find(
                      (field) =>
                        field.fieldName === "incident_summary" &&
                        field.lockedBy !== graphData.username
                    )
                    ? {
                      border: "1px solid red",
                      padding: "10px",
                      borderRadius: "5px",
                    }
                    : {}),
                }}
              >
                <h3 style={{ margin: "0 0 8px", fontSize: "13px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--mds_brand_appearance_default_default_text-color-secondary, #6b6b6b)" }}>Summary</h3>

                <div className="inc-summ-body scrollbar">
                  {props.incidentSummaryState?.incSummDescription ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.incidentSummaryState.incSummDescription.replace(/\n/g, "<br/>"),
                      }}
                    />
                  ) : (
                    <span className="inc-summ-placeholder">Please provide a summary of the incident</span>
                  )}
                </div>
              </div>
              <IsLocked
                field="incident_summary"
                lockedFields={incSummData.lockedFields}
                graphData={graphData}
              />

              {/* Image Upload Section */}
              <div
                style={{
                  margin: "16px 0 0",
                  border: "1px solid var(--mds_brand_appearance_default_border-color, #e0e0e0)",
                  borderRadius: "var(--mds_brand_border_medium_radius, 4px)",
                  overflow: "hidden",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "8px 14px",
                  background: "var(--mds_brand_appearance_neutral_weak_default_background-color, #f5f7f8)",
                  borderBottom: "1px solid var(--mds_brand_appearance_default_border-color, #e0e0e0)",
                }}>
                  <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.06em", textTransform: "uppercase", color: "var(--mds_brand_appearance_default_default_text-color-secondary, #6b6b6b)" }}>
                    Uploaded Images
                  </span>
                  <McButton
                    label="Add Image"
                    appearance="neutral"
                    variant="outlined"
                    fit="small"
                    leadingicon="camera"
                    click={() => handlePhotoModalClick("summary")}
                  />
                </div>
                <div style={{ padding: "12px 14px" }}>
                  {loadingImage.summary ? (
                    <Loading />
                  ) : (
                    <UploadedImages
                      images={uploadedSummaryImages}
                      previewImage={previewImage}
                      deleteImage={deleteImage}
                      deleteImageFor="summary"
                      error={errorInFetchingImages.summaryImages}
                    />
                  )}
                </div>
              </div>


              {/* Show Detection and Response description ONLY if it has content (old incidents), MTTD/MTTR grid always shown separately below */}
              {props.incidentSummaryState?.detectionAndResponseDescription &&
                props.incidentSummaryState.detectionAndResponseDescription.trim() !== '' && (
                  <>
                    <hr />
                    <div className="precedingEvents dar-div-tour-step">
                      <div
                        style={{
                          ...(Array.isArray(incSummData.lockedFields) &&
                            incSummData.lockedFields.find(
                              (field) =>
                                field.fieldName === "detection_and_response" &&
                                field.lockedBy !== graphData.username
                            )
                            ? {
                              border: "1px solid red",
                              padding: "10px",
                              borderRadius: "5px",
                            }
                            : {}),
                        }}
                      >
                        <h3 style={{ margin: "0 0 8px", fontSize: "13px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--mds_brand_appearance_default_default_text-color-secondary, #6b6b6b)" }}>Detection and Response</h3>
                        {/* (write how the incident was detected, who notified and how, consider detection improvements needed if
any or any other considerations. For response, who and when was it responded, what actions did they take, primarily note for delays, obstacles
etc.) */}

                        <div className="inc-summ-body">
                          {props.incidentSummaryState?.detectionAndResponseDescription ? (
                            <div dangerouslySetInnerHTML={{ __html: props.incidentSummaryState.detectionAndResponseDescription.replace(/\n/g, "<br/>") }} />
                          ) : (
                            <span className="inc-summ-placeholder">Please provide a description of the detection and response</span>
                          )}
                        </div>
                      </div>
                      <IsLocked
                        field="detection_and_response"
                        lockedFields={incSummData.lockedFields}
                        graphData={graphData}
                      />

                      <div className="metaData_contentGrid" style={{ marginTop: "12px" }}>
                        <div
                          className="metaData_col"
                          style={{
                            ...(Array.isArray(incSummData.lockedFields) &&
                              incSummData.lockedFields.find(
                                (field) =>
                                  field.fieldName === "mttd" &&
                                  field.lockedBy !== graphData.username
                              )
                              ? { outline: "1.5px solid red" }
                              : {}),
                          }}
                        >
                          <div className="metaData_colHead" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                            MTTD
                            <McTooltip position="top-left" fit="small" width={280}>
                              <McIcon slot="trigger" icon="info-circle" size="14" style={{ cursor: "pointer", color: "var(--mds_brand_appearance_primary_default_text-color, #0073ab)" }} />
                              <div>
                                <p style={{ margin: "0 0 4px" }}>Time between the problem first occurring, and when it was detected in minutes (by human or automation).</p>
                                {props.incidentSummaryState &&
                                  !props.incidentSummaryState.mttd &&
                                  props.recommendedKPIs?.mttd &&
                                  props.recommendedKPIs.mttd !== "0" && (
                                    <p style={{ margin: 0, fontWeight: 600 }}>Recommended: {props.recommendedKPIs.mttd} min</p>
                                  )}
                              </div>
                            </McTooltip>
                          </div>
                          <div className="metaData_colBody">
                            {props.incidentSummaryState?.mttd
                              ? props.incidentSummaryState.mttd + " min"
                              : "—"}
                          </div>
                        </div>

                        <div
                          className="metaData_col"
                          style={{
                            ...(Array.isArray(incSummData.lockedFields) &&
                              incSummData.lockedFields.find(
                                (field) =>
                                  field.fieldName === "mttr" &&
                                  field.lockedBy !== graphData.username
                              )
                              ? { outline: "1.5px solid red" }
                              : {}),
                          }}
                        >
                          <div className="metaData_colHead" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                            MTTR
                            <McTooltip position="top-left" fit="small" width={280}>
                              <McIcon slot="trigger" icon="info-circle" size="14" style={{ cursor: "pointer", color: "var(--mds_brand_appearance_primary_default_text-color, #0073ab)" }} />
                              <div>
                                <p style={{ margin: "0 0 4px" }}>Time between the issue being detected and an engineer beginning investigations in minutes.</p>
                                {props.incidentSummaryState &&
                                  !props.incidentSummaryState.mttrespond &&
                                  props.recommendedKPIs?.mttrespond &&
                                  props.recommendedKPIs.mttrespond !== "0" && (
                                    <p style={{ margin: 0, fontWeight: 600 }}>Recommended: {props.recommendedKPIs.mttrespond} min</p>
                                  )}
                              </div>
                            </McTooltip>
                          </div>
                          <div className="metaData_colBody">
                            {props.incidentSummaryState?.mttrespond
                              ? props.incidentSummaryState.mttrespond + " min"
                              : "—"}
                          </div>
                        </div>

                      </div>

                    </div>
                  </>
                )}
              </div>{/* sre-section-content */}
              {aiOpen && props.aiInsight && (
                <div className="sre-section-ai-col" onClick={e => e.stopPropagation()}>
                  <AiSuggestionsInline insight={props.aiInsight} sectionName="Incident Summary" dim={props.aiDim} />
                </div>
              )}
            </div>{/* sre-section-body */}
          </div>{/* sre-section-card */}
        </Col>

      </Row>
      <McModal
        heading="Incident Summary"
        open={modalOpen}
        dimension="large"
        backdropcloseactiondisabled
        escapecloseactiondisabled
        hiddenclose
        closed={() => { if (!savingInProgressRef.current) onSave(); }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

          {/* Summary textarea */}
          <div>
            <p style={{ margin: "0 0 4px", fontWeight: 600, fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--mds_brand_appearance_default_default_text-color-secondary, #6b6b6b)" }}>Summary</p>
            <button
              onClick={() => setShowFormatGuide(v => !v)}
              style={{ background: "none", border: "none", padding: "0 0 8px", cursor: "pointer", fontSize: "12px", color: "var(--mds_brand_appearance_primary_default_text-color, #0073ab)", display: "flex", alignItems: "center", gap: "4px" }}
            >
              {showFormatGuide ? "▲ Hide format guide" : "▼ Show format guide"}
            </button>
            {showFormatGuide && (
              <div style={{ fontSize: "13px", background: "var(--mds_brand_appearance_neutral-weak_default_background-color, #f5f5f5)", border: "1px solid var(--mds_brand_appearance_default_border-color, #e0e0e0)", borderRadius: "4px", padding: "12px 16px", marginBottom: "12px", lineHeight: "1.6" }}>
                <p style={{ margin: "0 0 6px" }}><strong>New Format:</strong> Combines Summary, Preceding Events, Impact, and Detection/Response in a timeline-based format.</p>
                <p style={{ margin: "0 0 4px" }}><strong>Structure:</strong></p>
                <p style={{ margin: "0 0 2px" }}>1. Brief overview (2–3 sentences)</p>
                <p style={{ margin: "0 0 2px" }}>2. Timeline: <code>• HH:MM:SS UTC – event description</code></p>
                <p style={{ margin: "0 0 10px" }}>3. Additional Context: Metrics, Systems, Teams</p>
                <p style={{ margin: "0 0 4px" }}><strong>Example:</strong></p>
                <p style={{ margin: "0 0 2px", color: "#555" }}>On April 8, 2026, a database capacity issue prevented label creation.</p>
                <p style={{ margin: "0 0 2px", color: "#555" }}>• 05:33 UTC – Alert received about label creation failures</p>
                <p style={{ margin: "0 0 2px", color: "#555" }}>• 06:16 UTC – Database confirmed at full capacity</p>
                <p style={{ margin: "0", color: "#555" }}>• 08:15 UTC – 40GB reclaimed, service restored</p>
              </div>
            )}
            <ReactQuill
              theme="snow"
              value={incSummData.incSummDescription}
              readOnly={!!(
                Array.isArray(incSummData.lockedFields) &&
                incSummData.lockedFields.find(f => f.fieldName === "incident_summary" && f.lockedBy !== graphData.username)
              )}
              onChange={(html) => { handleChange({ name: "incSummDescription", value: html }); handleFieldLocking("incident_summary"); }}
              onFocus={() => handleFieldLocking("incident_summary")}
              onBlur={() => handleFieldUnlocking("incident_summary")}
              modules={QUILL_MODULES}
              formats={QUILL_FORMATS}
              placeholder="Summarise your incident"
              style={{ background: "#fff", minHeight: "200px" }}
              />
            </div>
            <IsLocked field="incident_summary" lockedFields={incSummData.lockedFields} graphData={graphData} />

          {/* Legacy: Preceding Events */}
          {isLegacyFormat && (
            <div>
              <p style={{ margin: "0 0 4px", fontWeight: 600, fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--mds_brand_appearance_default_default_text-color-secondary, #6b6b6b)" }}>Preceding Events</p>
              <ReactQuill
                theme="snow"
                value={incSummData.preceEventsDescription}
                readOnly={!!(
                  Array.isArray(incSummData.lockedFields) &&
                  incSummData.lockedFields.find(f => f.fieldName === "preceeding_events" && f.lockedBy !== graphData.username)
                )}
                onChange={(html) => { handleChange({ name: "preceEventsDescription", value: html }); handleFieldLocking("preceeding_events"); }}
                onFocus={() => handleFieldLocking("preceeding_events")}
                onBlur={() => handleFieldUnlocking("preceeding_events")}
                modules={QUILL_MODULES}
                formats={QUILL_FORMATS}
                placeholder="Enter about the events"
                style={{ background: "#fff", minHeight: "200px" }}
              />
              <IsLocked field="preceeding_events" lockedFields={incSummData.lockedFields} graphData={graphData} />
            </div>
          )}

          {/* Legacy: Impact */}
          {isLegacyFormat && (
            <div>
              <p style={{ margin: "0 0 4px", fontWeight: 600, fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--mds_brand_appearance_default_default_text-color-secondary, #6b6b6b)" }}>Impact</p>
              <ReactQuill
                theme="snow"
                value={incSummData.impact}
                readOnly={!!(
                  Array.isArray(incSummData.lockedFields) &&
                  incSummData.lockedFields.find(f => f.fieldName === "impact" && f.lockedBy !== graphData.username)
                )}
                onChange={(html) => { handleChange({ name: "impact", value: html }); handleFieldLocking("impact"); }}
                onFocus={() => handleFieldLocking("impact")}
                onBlur={() => handleFieldUnlocking("impact")}
                modules={QUILL_MODULES}
                formats={QUILL_FORMATS}
                placeholder="Impact"
                style={{ background: "#fff", minHeight: "200px" }}
              />
              <IsLocked field="impact" lockedFields={incSummData.lockedFields} graphData={graphData} />
            </div>
          )}

          {/* Legacy: Detection and Response */}
          {isLegacyFormat && (
            <div>
              <p style={{ margin: "0 0 4px", fontWeight: 600, fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--mds_brand_appearance_default_default_text-color-secondary, #6b6b6b)" }}>Detection and Response</p>
              <ReactQuill
                theme="snow"
                value={incSummData.detectionAndResponseDescription}
                readOnly={!!(
                  Array.isArray(incSummData.lockedFields) &&
                  incSummData.lockedFields.find(f => f.fieldName === "detection_and_response" && f.lockedBy !== graphData.username)
                )}
                onChange={(html) => { handleChange({ name: "detectionAndResponseDescription", value: html }); handleFieldLocking("detection_and_response"); }}
                onFocus={() => handleFieldLocking("detection_and_response")}
                onBlur={() => handleFieldUnlocking("detection_and_response")}
                modules={QUILL_MODULES}
                formats={QUILL_FORMATS}
                placeholder="Detection and Response"
                style={{ background: "#fff", minHeight: "200px" }}
              />
              <IsLocked field="detection_and_response" lockedFields={incSummData.lockedFields} graphData={graphData} />
            </div>
          )}


        </div>

        <McButton
          slot="primaryAction"
          appearance="primary"
          click={onSave}
        >
          OK
        </McButton>
      </McModal>

      {/* Photo Upload Modal */}
      <PhotoUploadModal
        modalOpen={photoModal}
        handleModal={handlePhotoModalClick}
        handleModalClose={handlePhotoModalClose}
        files={[]}
        handleFiles={handleFiles}
        fileChange={fileChangeWithModalClose}
        hanldePreviewModal={hanldePreviewModal}
        imageToPreview={imageToPreview}
        previewModal={previewModal}
        error={error}
        errorMessage={errorMessage}
        photoFor={photosFor}
      />

      {/* Photo Preview Modal */}
      <PhotoPreviewModal
        imageToPreview={imageToPreview}
        previewModal={previewModal}
        hanldePreviewModal={hanldePreviewModal}
      />
    </div>
  );
}

export default IncidentSummary;
